var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CENTER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #CENTER .cls-1, #CENTER .cls-2 {fill:#f5f5f5}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-590.086 -414.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.086 414.919a15.983 15.983 0 1 0 .034 0zm0 30a14 14 0 1 1 14-14 14.173 14.173 0 0 1-14 14z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.524 426.358v9.128h9.128v-9.128zm4.684 1.014H608l-5.464 5.464v-1.794zm-3.67 2.953v-1.793l1.159-1.16h1.794zm.442-2.953l-.442.443v-.443zm-.442 6.181l6.181-6.181h.919v.875l-6.225 6.225h-.875zm3.386.919h-1.794l5.508-5.508v1.794zm3.714-3v1.793l-1.2 1.2h-1.793zm-.487 3l.487-.486v.486z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.99 425.848h-4.383v-.913h3.47v-3.469h.913z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.607 425.848h-4.383v-4.382h.913v3.469h3.47z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.99 440.444h-.913v-3.47h-3.47v-.913h4.383z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.136 440.444h-.913v-4.384h4.383v.913h-3.47z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToCenter);
export default __webpack_public_path__ + "static/media/to-center.e11d1f28afea694328ff8269b9910d41.svg";
export { ForwardRef as ReactComponent };